if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super()
      if (this.hasChildNodes()) this.init()
    }

    init() {
      this.form = this.querySelector('.js-product-form')
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false
        this.cartDrawer = document.querySelector('cart-drawer')
        this.submitBtn = this.querySelector('[name="add"]')

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this))
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return

      evt.preventDefault()

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100)
      }

      this.errorMsg = null
      this.setErrorMsgState()

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true')

      // Add "loading" class
      this.submitBtn.classList.add('loading')

      const formData = new FormData(this.form)
      let sections = 'cart-icon-bubble'
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`
      }

      formData.append('sections_url', window.location.pathname)
      formData.append('sections', sections)

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      }

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`)
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status)
        const oldCartData = await oldCartResponse.json()

        // Array containing all items to add to cart
        const items = [
          {
            id: parseInt(formData.get('id')),
            quantity: parseInt(formData.get('quantity') || '1'),
          },
        ]

        // Nested products
        const nestedProductBtns = document.querySelectorAll('.nested-product-btn')

        nestedProductBtns.forEach((btn) => {
          const selectedInput = btn.querySelector('.nested-product-btn__input:checked')
          if (!selectedInput) return
          const parentId = parseInt(btn.dataset.parentId)

          if (items[0].id === parentId) {
            const variantId = parseInt(selectedInput.value)
            items.push({
              id: variantId,
              quantity: 1,
              parent_id: items[0].id,
            })
          }
        })

        // Extended warranty logic
        const selectedWarranties = document.querySelectorAll('.extended-warranty input:checked')

        selectedWarranties.forEach((el) => {
          const variantId = parseInt(el.value)
          if (!isNaN(variantId)) {
            items.push({
              id: variantId,
              quantity: items[0].quantity,
            })
          }
        })

        // Pool Builder Logic
        const builderEl = document.querySelector('.pool-builder')
        const mainProductTitle = document.querySelector('.js-product-form')?.closest('[data-product-title]')?.dataset?.productTitle || '';
        const mainVariantIdForBuilder = items[0]?.id;

        // Silently replace existing build if same pool product is already in cart
        if (builderEl && mainVariantIdForBuilder) {
          const existingBuild = oldCartData.items.find(
            (ci) => ci.properties && ci.properties._builder_build === 'true' && ci.variant_id === mainVariantIdForBuilder
          )
          if (existingBuild) {
            const oldQuoteId = existingBuild.properties._builder_quote_id
            const linesToRemove = {}
            oldCartData.items.forEach((ci) => {
              if (!ci.properties) return
              const isParent = ci.properties._builder_build === 'true' && ci.variant_id === mainVariantIdForBuilder
              const isChild = ci.properties._builder_parent === String(mainVariantIdForBuilder)
              const matchesQuote = oldQuoteId && ci.properties._builder_quote_id === oldQuoteId
              if (isParent || isChild || matchesQuote) {
                linesToRemove[ci.key] = 0
              }
            })
            if (Object.keys(linesToRemove).length) {
              const removeResp = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ updates: linesToRemove }),
              })
              if (!removeResp.ok) {
                console.error('Failed to remove old build from cart')
              }
            }
          }
        }

        // Generate a quote ID for builder builds
        let builderQuoteId = ''
        if (builderEl) {
          const counter = parseInt(localStorage.getItem('gp_build_counter') || '0', 10) + 1
          localStorage.setItem('gp_build_counter', String(counter))
          builderQuoteId = 'GP-' + String(counter).padStart(3, '0')
          items[0].properties = items[0].properties || {}
          items[0].properties._builder_build = 'true'
          items[0].properties._builder_quote_id = builderQuoteId
        }

        // Step/substep products (radio + checkbox)
        const selectedBuilderProducts = document.querySelectorAll(
          '.pool-builder .builder-product-input:checked:not([data-no-product]):not([data-promo])'
        )

        selectedBuilderProducts.forEach((el) => {
          const variantId = parseInt(el.dataset.variantId)
          if (!isNaN(variantId)) {
            const isFree = el.dataset.free === 'true'
            const props = { _builder_parent: String(mainVariantIdForBuilder), _builder_quote_id: builderQuoteId }
            if (isFree) props._builder_free = 'true'
            items.push({
              id: variantId,
              quantity: items[0].quantity,
              properties: props,
            })
          }
        })

        // Promo products (checkboxes)
        const selectedPromos = document.querySelectorAll(
          '.builder-wrapper .builder-promo-input:checked'
        )

        selectedPromos.forEach((el) => {
          const variantId = parseInt(el.dataset.variantId)
          if (!isNaN(variantId)) {
            const discount = parseInt(el.dataset.discount || 0, 10)
            const isFree = el.dataset.free === 'true'
            const props = { _builder_parent: String(mainVariantIdForBuilder), _builder_promo: 'true', _builder_quote_id: builderQuoteId }
            if (isFree) props._builder_free = 'true'
            if (discount > 0 && discount < 100) props._builder_discount = String(discount)
            items.push({
              id: variantId,
              quantity: items[0].quantity,
              properties: props,
            })
          }
        })

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items,
            sections,
            sections_url: window.location.pathname,
          }),
        })

        const data = await response.json()
        let error = typeof data.description === 'string' ? data.description : data.message
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '))
        }

        if (data.status) this.setErrorMsgState(error)

        if (!response.ok) throw new Error(response.status)

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart
          }, 300)
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data)

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer')
          if (quickAddDrawer) quickAddDrawer.addedToCart()

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(data, !quickAddDrawer && theme.settings.afterAtc === 'drawer')
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items')
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload()
                } else {
                  cartItems.refresh()
                }
              }
            }
          }, 700)
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`)
        if (!newCartResponse.ok) throw new Error(newCartResponse.status)
        const newCartData = await newCartResponse.json()
        const itemInOldCart = oldCartData.items.filter((item) => item.variant_id === data.variant_id)[0]

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(
            new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id,
                oldQuantity: itemInOldCart.quantity,
                newQuantity: itemInOldCart.quantity === data.quantity ? itemInOldCart.quantity : data.quantity,
              },
            })
          )
        } else {
          this.dispatchEvent(
            new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id,
              },
            })
          )
        }
      } catch (error) {
        console.log(error) // eslint-disable-line
        this.dispatchEvent(
          new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: {
              error: this.errorMsg?.textContent,
            },
          })
        )

        if (this.cartDrawer) this.cartDrawer.refresh(true)
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success')
        this.submitBtn.removeAttribute('aria-disabled')
        setTimeout(() => {
          this.submitBtn.classList.remove('is-success')
        }, 1400)
        // Remove "loading" class
        this.submitBtn.classList.remove('loading')
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble')
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble']
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error')
      if (!this.errorMsg) return

      this.errorMsg.hidden = !error
      if (error) {
        this.errorMsg.innerHTML = ''
        const errorArray = Array.isArray(error) ? error : [error]
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>')
          this.errorMsg.insertAdjacentText('beforeend', err)
        })
      }
    }
  }

  customElements.define('product-form', ProductForm)
}

// Pre-order disclaimer
const preOrderCheckbox = document.querySelector('.pre-order-disclaimer__input')

if (preOrderCheckbox) {
  preOrderCheckbox.addEventListener('invalid', () => {
    preOrderCheckbox.setCustomValidity(theme.strings.required)
  })

  preOrderCheckbox.addEventListener('input', () => {
    preOrderCheckbox.setCustomValidity('')
  })
}
